export const USER_LOADED = 'USER_LOADED';
export const USER_FAIL = 'USER_FAIL';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const GET_EVENTS = 'GET_EVENTS';
export const ERROR_EVENTS = 'ERROR_EVENTS';
export const USER_DETAILS = 'USER_DETAILS';
export const ERROR_USER_DETAILS = 'ERROR_USER_DETAILS';